/** Minimal surface of @microsoft/clarity used by the adapter (name-only event). */
export interface ClaritySurface {
  identify(customId: string): void
  setTag(key: string, value: string | string[]): void
  event(name: string): void
}

function setTags(clarity: ClaritySurface, tags: Record<string, unknown>): void {
  for (const [key, value] of Object.entries(tags)) {
    if (value === null || value === undefined || value === '') continue
    try {
      clarity.setTag(key, value as string | string[])
    } catch {
      /* fail-soft: analytics must never break the app */
    }
  }
}

export function applyIdentify(
  clarity: ClaritySurface,
  id: string,
  traits: Record<string, unknown> = {},
): void {
  try {
    clarity.identify(id)
  } catch {
    /* fail-soft */
  }
  setTags(clarity, traits)
}

export function applyTrack(
  clarity: ClaritySurface,
  eventName: string,
  props: Record<string, unknown> = {},
): void {
  try {
    clarity.event(eventName)
  } catch {
    /* fail-soft */
  }
  setTags(clarity, props)
}
